/* eslint-disable react/prop-types */
// @flow
/* eslint-disable flowtype/generic-spacing */
import React, { useState, useRef, useEffect } from 'react';
import { t } from 'javascripts/utils/withTranslation';
import classNames from 'classnames';
import IconLink, {
  type IconLinkType,
} from 'components/atoms/icon-link/react/IconLink';
import Link, { type LinkType } from 'components/atoms/link/react/Link';
import Headline, {
  type HeadlineProps,
} from 'components/atoms/headline/react/Headline';
import randomString from 'javascripts/utils/random-id';
import { MEDIA_QUERIES } from 'javascripts/constants';
import Input from 'components/atoms/input/react/Input';
import Button from 'components/atoms/button/Button';
import addOverlayLink from 'javascripts/utils/overlay-link';

type Combined = {
  ...LinkType,
  ...IconLinkType,
  attr?: any,
  openInputOnClick?: boolean,
};

export type Props = {
  headline?: HeadlineProps,
  items: Array<{
    ...Combined,
    ...IconLinkType & { openInputOnClick?: boolean },
  }>,
  id?: string,
  className?: string,
  /** Renders multiple columns and devider lines */
  multiple?: boolean,
  attr?: any,
};

const LinkComponent = (compProps: Combined) => {
  const { text, openInputOnClick, ...props } = compProps;
  const overlay = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (overlay.current) {
      addOverlayLink(overlay.current, openInputOnClick);
    }
  }, []);

  if (!text) {
    return null;
  }
  // $FlowFixMe
  if ((props.icon && props.link) || (openInputOnClick && props.icon)) {
    // $FlowFixMe
    return (
      <IconLink
        // $FlowFixMe
        {...(props: IconLinkType)}
        // $FlowFixMe
        link={openInputOnClick ? undefined : props.link}
        ref={overlay}
        overlayTarget="link-list__item"
      >
        {text}
      </IconLink>
    );
  }
  // $FlowFixMe
  if (props.link || props.openInputOnClick) {
    return (
      // $FlowFixMe
      <Link {...(props: any)} ref={overlay} overlayTarget="link-list__item">
        {text}
      </Link>
    );
  }
  return null;
};

const LinkList = (props: Props): React$Element<'div'> => {
  const { headline, items = [], id, className } = props;
  const [inputValue, setInputValue] = useState('https://');
  const [openInput, setOpenInput] = useState<string | void>();
  const labelId = (id && `${id}-label`) || `link-list-${randomString()}-label`;
  const linkListClasses = classNames(
    'link-list',
    props.multiple && 'link-list--multi',
    className
  );

  const handleOpenInputLink = () => {
    window.open(
      `${inputValue}${openInput || 'Baden-Württemberg'}`,
      'Mastodon',
      'width=600, height=600'
    );
  };

  const handleOnClick = (link: string, openInputOnClick?: boolean) => {
    if (openInputOnClick) {
      setOpenInput(link);
    }
  };

  return (
    <div className={linkListClasses}>
      {headline && headline.text && (
        <div className="link-list__headline">
          <Headline {...headline} id={labelId}>
            {headline.text}
          </Headline>
        </div>
      )}
      <nav className="link-list__nav" aria-labelledby={headline && labelId}>
        <ul className="link-list__list">
          {items.map((item, index) => {
            const dataName = (item.attr: any)['data-name'];

            // handling share items visibility on mobile and desktop
            if (dataName.startsWith('Whatsapp')) {
              const isDesktopShareLink = dataName === 'Whatsapp Desktop';
              const isDesktop = window.matchMedia(MEDIA_QUERIES.l).matches;

              if (isDesktop && !isDesktopShareLink) {
                return null;
              }

              if (!isDesktop && isDesktopShareLink) {
                return null;
              }
            }

            return (
              <li className="link-list__item" key={index}>
                {/* $FlowFixMe */}
                <LinkComponent
                  {...item}
                  className={classNames(
                    item.className,
                    props.multiple && 'js-overlay-link'
                  )}
                  attr={{
                    'data-overlay-target': props.multiple && 'link-list__item',
                  }}
                  key={index}
                  onClick={() =>
                    handleOnClick(item.link, item.openInputOnClick)
                  }
                />
              </li>
            );
          })}
        </ul>
      </nav>
      {openInput && (
        <div className="link-list__input">
          <Input
            name="mastodon"
            value={inputValue}
            onChange={(event) => setInputValue(event.target.value)}
          />
          <p className="link-list__input-desc">
            {t(
              'Bitte geben Sie die Adresse des Mastodon-Servers ein, auf dem Sie teilen möchten.'
            )}
          </p>
          <Button
            icon="arrow-right-line"
            iconTitle={t('Teilen')}
            onClick={handleOpenInputLink}
          >
            {t('Teilen')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default LinkList;
